/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, cloneElement } from 'react';
import { range } from 'lodash';
export var RepeatComponent = function (_a) {
    var count = _a.count, children = _a.children;
    var item = jsx(Fragment, null, children);
    return (jsx(Fragment, null, range(0, count).map(function (i) {
        return cloneElement(item, { key: i });
    })));
};
//# sourceMappingURL=RepeatComponent.js.map